import React from 'react';
import { Block, BLOCKS, Inline, INLINES } from '@contentful/rich-text-types';

import { ISplitAssetWithTextFields } from '@/types/contentful';

import RichText from '../../RichText';
import { EmbeddedInlineEntryNode } from '../../RichText/Nodes';
import GlLink from '../../Link';

import { Asset } from '../../AtomicComponents/Asset';

export function AssetWithText({
  asset,
  heading,
  body
}: ISplitAssetWithTextFields) {
  return (
    <div
      className="m-0 flex flex-col p-3 tablet:p-4 desktop:mx-4 desktop:my-0"
      data-testid="split-module-asset-with-text"
    >
      <div className="mb-6 flex w-full items-center justify-center">
        <Asset
          asset={asset}
          className="flex h-full w-full items-center justify-center overflow-hidden rounded-card-shape [&>img]:!h-auto [&>img]:object-cover"
        />
      </div>

      <h3 className="typography-display-3 px-8 py-2 desktop:px-4 desktop:py-2">
        {heading}
      </h3>

      {body && (
        <div className="flex flex-col px-8 py-2 desktop:px-4 desktop:py-2">
          <RichText
            data={body}
            overrideOptions={{
              [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => (
                <p className="text-sm font-normal leading-[22px] text-black desktop:text-lg desktop:leading-[26px]">
                  {children}
                </p>
              ),
              [INLINES.HYPERLINK]: (node, children) => (
                <GlLink
                  href={node.data.uri}
                  className="text-black underline transition-colors duration-200 ease-in-out hover:text-navy desktop:hover:text-navy"
                >
                  {children}
                </GlLink>
              ),
              [INLINES.EMBEDDED_ENTRY]: (node, children) => (
                <EmbeddedInlineEntryNode
                  node={node}
                  colour="defaultText"
                  fontWeight="p"
                >
                  {children}
                </EmbeddedInlineEntryNode>
              )
            }}
          />
        </div>
      )}
    </div>
  );
}
